import { Extension } from "@tiptap/core";
import { type EditorState, NodeSelection, TextSelection, type Transaction } from "@tiptap/pm/state";

/** Swap the top-level block holding the selection with its neighbour above (-1) or below (1). */
export function moveBlock(state: EditorState, dir: -1 | 1): Transaction | null {
  const { doc, selection } = state;
  const index = selection.$from.index(0);
  const target = index + dir;
  if (target < 0 || target >= doc.childCount) return null;
  const node = doc.child(index);
  const other = doc.child(target);
  let start = 0;
  for (let i = 0; i < Math.min(index, target); i++) start += doc.child(i).nodeSize;
  const nodeStart = dir === 1 ? start : start + other.nodeSize;
  const offset = selection.from - nodeStart;
  const tr = state.tr.replaceWith(
    start,
    start + node.nodeSize + other.nodeSize,
    dir === 1 ? [other, node] : [node, other],
  );
  const newStart = dir === 1 ? start + other.nodeSize : start;
  tr.setSelection(
    selection instanceof NodeSelection
      ? NodeSelection.create(tr.doc, newStart)
      : TextSelection.near(tr.doc.resolve(Math.min(newStart + offset, tr.doc.content.size))),
  );
  return tr.scrollIntoView();
}

export const MoveBlockKeymap = Extension.create({
  name: "klarityMoveBlock",
  addKeyboardShortcuts() {
    const move = (dir: -1 | 1) => () => {
      if (this.editor.isDestroyed || !this.editor.isEditable) return false;
      const tr = moveBlock(this.editor.state, dir);
      if (!tr) return false;
      this.editor.view.dispatch(tr);
      return true;
    };
    return { "Alt-Shift-ArrowUp": move(-1), "Alt-Shift-ArrowDown": move(1) };
  },
});
